import { createContext, useContext } from 'react';

export type TenantDataContextType = {
	tenantContexts: ReadonlyArray<{
		readonly cloudId: string;
		readonly orgId: string;
		readonly devaiEntitlementId: string | null;
		readonly devAiActivationId: string | null;
	}>;
};

export const TenantDataContext = createContext<TenantDataContextType | null>(null);

export const useTenantData = () => {
	const context = useContext(TenantDataContext);
	if (!context) {
		throw new Error('useTenantData must be used within a TenantDataProvider');
	}
	return context;
};
